




















import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "ClinicMessage",
})
export default class ClinicMessage extends Vue {}
